import { render, staticRenderFns } from "./orangemoneyrep.vue?vue&type=template&id=4e6e1e82&scoped=true"
import script from "./orangemoneyrep.vue?vue&type=script&lang=js"
export * from "./orangemoneyrep.vue?vue&type=script&lang=js"
import style0 from "./orangemoneyrep.vue?vue&type=style&index=0&id=4e6e1e82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6e1e82",
  null
  
)

export default component.exports